import {
    createSlice,
    current
} from '@reduxjs/toolkit';
import {
    getWarehouseItemTransferList,
    addNewWarehouseItemTransfer,
    updateWarehouseItemTransfer,
    deleteWarehouseItemTransfer,
    getWarehouseItemTransfer,
    warehouseItemTransferReception
} from '../warehouseItemTransfer/thunk';

export const initialState = {
    warehouseItemList: [],
    itemWarehouseItemTransfer: null,
    isWarehouseItemTransferLoading: false,
    isWarehouseItemTransferSuccess: false,
    isCheckStock: false,
    isCheckStockOk: false,
    checkStockErrors: null,

    dataWarehouseItemTransfer: null,
    statementList: [],
    statementListSelect: [],
    isLoadingList: false,
    isAdding: false,
    isAdded: false,
    isAddError: false,
    isUpdating: false,
    isUpdated: false,
    isUpdateError: false,
    isDeleting: false,
    isDeleted: false,
    isDeleteError: false,
    requireCloseModal: false,
    registerDisabled: false,
    requireReloadSelectionItemsGrid: false,
    exists: false,
    isReception: false,
    isReceived: false,
    isReceptionError: false
};

const WarehouseItemTransferSlice = createSlice({
    name: 'WarehouseItemTransfers',
    initialState,
    reducers: {
        setRequireCloseModal(state, action) {
            state.requireCloseModal = action.payload;
        },
        setWarehouseItemTransferList(state, action){
            state.warehouseItemList = action.payload;
        }
    },
    extraReducers: builder => {
        builder.addCase(getWarehouseItemTransfer.fulfilled, (state, action) => {
            state.isWarehouseItemTransferLoading = false;
            state.isWarehouseItemTransferSuccess = true;
            state.itemWarehouseItemTransfer = action.payload;
            state.isLoadingList = false;
        });
        builder.addCase(getWarehouseItemTransfer.pending, state => {
            state.isWarehouseItemTransferLoading = true;
            state.isWarehouseItemTransferSuccess = null;
            state.itemWarehouseItemTransfer = null;
            state.error = null;
            state.isLoadingList = true;
        });
        builder.addCase(getWarehouseItemTransfer.rejected, (state, action) => {
            state.isWarehouseItemTransferLoading = false;
            state.isWarehouseItemTransferSuccess = false;
            state.itemWarehouseItemTransfer = null;
            state.error = action.error.message;
            state.isLoadingList = false;
        });

        builder.addCase(getWarehouseItemTransferList.pending, state => {
            state.isWarehouseItemTransferSuccess = true;
            state.error = null;
            state.isLoadingList = true;
        });
        builder.addCase(getWarehouseItemTransferList.fulfilled, (state, action) => {
            state.warehouseItemList = action.payload;
            state.isLoadingList = false;
            state.isWarehouseItemTransferSuccess = true;
        });
        builder.addCase(getWarehouseItemTransferList.rejected, (state, action) => {
            state.warehouseItemList = []
            state.error = action.payload || null;
            state.isLoadingList = false;
            state.isWarehouseItemTransferSuccess = true;
        });
        builder.addCase(addNewWarehouseItemTransfer.fulfilled, (state, action) => {
            state.warehouseItemList.push(action.payload);
            state.statementList.push(action.payload);
            state.isLoadingList = false;
            state.isAdding = false;
            state.isAdded = true;
            state.isAddError = false;
            state.requireCloseModal = true;
        });
        builder.addCase(addNewWarehouseItemTransfer.pending, (state, action) => {
            state.isLoadingList = true;
            state.isAdding = true;
            state.isAdded = false;
            state.isAddError = false;
        });
        builder.addCase(addNewWarehouseItemTransfer.rejected, (state, action) => {
            state.error = action.payload || null;
            state.isLoadingList = false;
            state.isAdding = false;
            state.isAdded = false;
            state.isAddError = true;
        });

        builder.addCase(updateWarehouseItemTransfer.fulfilled, (state, action) => {
            state.warehouseItemList = state.warehouseItemList.map(warehouseItem =>
                warehouseItem._id.toString() === action.payload._id.toString()
                    ? {
                        ...warehouseItem,
                        ...action.payload
                    }
                    : warehouseItem
            );
            state.isLoadingList = false;
            state.isUpdating = false;
            state.isUpdated = true;
            state.isUpdateError = false;
            state.requireCloseModal = true;
        });
        builder.addCase(updateWarehouseItemTransfer.pending, state => {
            state.isLoadingList = true;
            state.isUpdating = true;
            state.isUpdated = false;
            state.isUpdateError = false;
        });
        builder.addCase(updateWarehouseItemTransfer.rejected, (state, action) => {
            state.error = action.payload || null;
            state.isLoadingList = false;
            state.isUpdating = false;
            state.isUpdated = false;
            state.isUpdateError = true;
        });

        builder.addCase(deleteWarehouseItemTransfer.fulfilled, (state, action) => {
            state.warehouseItemList = current(state.warehouseItemList).filter(
                item => item._id !== action.payload._id
            );
            state.statementList = current(state.statementList).filter(item =>
                item._id !== action.payload._id
            );
            state.isLoadingList = false;
            state.isDeleting = false;
            state.isDeleted = true;
            state.isDelete = false;
            state.requireCloseModal = true;
        });
        builder.addCase(deleteWarehouseItemTransfer.pending, (state, action) => {
            state.isLoadingList = true;
            state.isDeleting = false;
            state.isDeleted = true;
            state.isDelete = false;
        });
        builder.addCase(deleteWarehouseItemTransfer.rejected, (state, action) => {
            state.error = action.payload || null;
            state.isLoadingList = false;
            state.isDeleting = false;
            state.isDeleted = false;
            state.isDelete = true;
        });

        builder.addCase(warehouseItemTransferReception.rejected, (state, action) => {
            state.error = action.payload || null;
            state.isReception = false;
            state.isReceived = false
            state.isReceptionError = true;
        });
        builder.addCase(warehouseItemTransferReception.fulfilled, (state, action) => {
            state.isReception = false;
            state.isReceived = true
            state.isReceptionError = false;
            state.requireCloseModal = true;
        });
        builder.addCase(warehouseItemTransferReception.pending, (state, action) => {
            state.isReception = true;
            state.isReceived = false
            state.isReceptionError = false;
        });

        warehouseItemTransferReception
    },
});

export const {
    setRequireCloseModal,
    setWarehouseItemTransferList,
} = WarehouseItemTransferSlice.actions;

export default WarehouseItemTransferSlice.reducer;